import { IconButton, Typography } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers";

// the stock header stacks both arrows on the right; this one brackets the label
export function DueDateCalendarHeader(props: PickersCalendarHeaderProps) {
    const month = props.currentMonth;

    return (
        <div style={{ display: "flex", alignItems: "center", padding: "0 4px", minHeight: 34 }}>
            <IconButton size="small" disabled={props.disabled}
                        onClick={() => props.onMonthChange(month.clone().subtract(1, "month"))}>
                <ChevronLeft fontSize="small" />
            </IconButton>

            <Typography variant="body2" align="center" style={{ flex: 1, fontWeight: 500 }}>
                {month.format("MMMM YYYY")}
            </Typography>

            <IconButton size="small" disabled={props.disabled}
                        onClick={() => props.onMonthChange(month.clone().add(1, "month"))}>
                <ChevronRight fontSize="small" />
            </IconButton>
        </div>
    );
}
